// src/components/audition-booking-wizard/PaymentModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const PaymentModal = ({ show, handleClose, checkoutUrl, pollingRef }) => {
    return (
        <Modal 
            show={show} 
            onHide={() => {
                handleClose();
                if (pollingRef.current) {
                    clearInterval(pollingRef.current);
                }
            }} 
            size="lg" 
            centered
            contentClassName="bg-dark border-0 rounded-4 overflow-hidden shadow-lg"
        >
            <Modal.Header closeButton closeVariant="white" className="border-secondary bg-black">
                <Modal.Title className="text-white fs-5">Complete Your Secure Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 bg-black text-center">
                {checkoutUrl ? (
                    <iframe
                        src={checkoutUrl}
                        title="Payment"
                        style={{ width: "100%", height: "600px", border: "none" }}
                    />
                ) : (
                    <p className="text-white p-4">Loading payment gateway...</p>
                )}
            </Modal.Body>
            <Modal.Footer className="border-secondary bg-black">
                <Button variant="outline-light" onClick={() => {
                    handleClose();
                    if (pollingRef.current) {
                        clearInterval(pollingRef.current);
                    }
                }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PaymentModal;